import { axios } from '@/utils/request'

const api = {
  order: '/order/remove',
  enterprise:'/enterprise/brand',
  basicdata:'/basicdata/orderType'
}


export function removeOrderList (parameter) {//查询
  return axios({
    url: api.order + '/removeOrderList',
    method: 'get',
    params: parameter,
  })
}



export function exportOrder  (parameter) {//退单列表导出
  return axios({
    url: '/order/remove/exportOrder',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  })
}
export function getList   (parameter) {
  return axios({
    url: api.basicdata + `/getList/${parameter}`,
    method: 'get',
  })
}
export function findByDeptId   (parameter) {
  return axios({
    url: `system/user/findByDeptId/${parameter}`,
    method: 'get',
  })
}

export function selectBrand   (parameter) {
  return axios({
    url: api.enterprise + '/selectBrand',
    method: 'get',
    params: parameter,
  })
}
export function selectChannel   (parameter) {
  return axios({
    url: 'enterprise/channel/selectChannel',
    method: 'get',
    params: parameter,
  })
}

export function selectSource   (parameter) {
  return axios({
    url: 'enterprise/source/selectSource',
    method: 'get',
    params: parameter,
  })
}

export function selectModel (parameter) {
  return axios({
    url: 'enterprise/model/selectModel',
    method: 'get',
    params: parameter,
  })
}
export const accessoryExport = api.accessory + '/export'